import React, { useEffect } from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { Col, Container, Row } from 'react-bootstrap';
import { destinationsData } from '../../utils/data';
import Cards from '../../components/Cards/Cards';
import { Helmet } from 'react-helmet-async';

const Destinations = () => {

  useEffect(() => {
    document.title = "Destinations | MitoLyn Tours";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Top Travel Destinations in India | Shivay Tour and Travells</title>
        <meta
          name="description"
          content="Discover your next travel destination with Shivay Tour and Travells. Explore India's most breathtaking spots, from majestic mountains to vibrant cities."
        />
        <meta name="keywords" content="travel destination, Gujarat tours, India travel" />

        <link rel="canonical" href="https://www.shivaytourandtravells.com/destination" />

        {/* JSON-LD Structured Data for Destinations */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ItemList",
              "name": "Top Travel Destinations in India",
              "description": "A curated list of popular travel destinations in India.",
              "itemListElement": destinationsData.map((dest, idx) => ({
                "@type": "ListItem",
                "position": idx + 1,
                "name": dest.name,
                "url": `https://www.shivaytourandtravells.com/destination/${dest.slug}`,
              })),
            }),
          }}
        />

      </Helmet>
      <Breadcrumbs title="Destinations" pagename="Destinations" />

      <section className="py-5">
        <Container>
          <Row>
            {destinationsData.map((destination, index) => (
              <Col key={index} md={3} sm={6} className="pb-4">
                <Cards destination={destination} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Destinations;
